module.exports = __webpack_public_path__ + "img/youtube.36cb43e2.svg";